import { CheckCircle } from "lucide-react";

const services = [
  "Precios dinámicos y gestión de ingresos",
  "Gestión de canales y distribución multiplataforma",
  "Optimización de anuncios",
  "Gestión de reservas",
  "Asistencia 24/7 en reservas",
  "Análisis de resultados y reportes",
  "Procesamiento automatizado de pagos",
  "Marketing y publicidad",
  "Reportes y estados de cuenta del propietario",
  "Acceso al Portal del Propietario",
  "Seguro",
  "Cumplimiento fiscal",
  "Fotografía profesional",
  "Asignación de un Property Manager",
];

const PropertyManagementServices = () => (
  <section className="py-16 bg-gray-50">
    <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="text-center mb-12">
        <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
          ¿Qué incluye nuestro servicio?
        </h2>

        <p className="text-xl text-gray-600 max-w-3xl mx-auto">
          Una solución completa para la gestión de tu propiedad vacacional
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {services.map((servicio) => (
          <div
            key={servicio}
            className="flex items-center p-4 bg-white rounded-lg shadow-sm hover:shadow-md transition-shadow"
          >
            <CheckCircle className="w-5 h-5 text-green-500 mr-3 flex-shrink-0" />
            <span className="text-gray-800 font-medium">{servicio}</span>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default PropertyManagementServices;
